import { BrowserRouter as Router } from "react-router-dom";
import NavBar from "./Components/Pages/NavBar";

const App = () => {
  return (
    <Router>
      <NavBar/>
    </Router>
  );
};

export default App;
